"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDistrictHeatingOutage = function IconDistrictHeatingOutage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33.156 24.52 24.03 8.71l-9.126 15.81-9.137 15.81h36.526zm-9.127-11.81 7.395 12.81 7.403 12.81H9.232l7.404-12.81zm-1.219 9.62h2.37l-.45 8h-1.46zm2.19 11h-2v-2h2z",
    clipRule: "evenodd"
  })));
};

export { IconDistrictHeatingOutage, IconDistrictHeatingOutage as default };
